import type { InputHTMLAttributes } from 'react';

import { ClassNames } from '@/shared/classNames';

type CheckboxProperties = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const Checkbox = ({ className, ...properties }: CheckboxProperties) => (
  <input
    className={ClassNames(
      'border-line-strong bg-raised text-action accent-action size-5 shrink-0 rounded disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    type="checkbox"
    {...properties}
  />
);
